import { required, numeric } from 'vuelidate/lib/validators'

const defaultEl = {
  id: null,
  name: {},
  code: '',
  order: ''
};

export default {
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  validations: {
    editEl: {
      name: { required },
      code: { required },
      order: { required, numeric }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.material.group.edit');
      }
      return this.$t('menu.material.group.new');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        const self = this;
        this.ApiRequest.request('material/group/edit', this.ApiRequest.REQUEST_POST, { group: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
